import React, { ReactElement, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import alertPic from '../../assets/alert.svg';
import styles from './searchSelector.module.css';
import useSearchSelector from './useSearchSelector';

export type SearchSelectorProps = {
  htmlFor: string;
  title: string;
  subtitle?: string;
  value: string;
  changeHandler: (val: string) => void;
  fetch: (val: string) => Promise<Array<string>> | undefined;
  selectHandler?: (val: string) => void;
  highLightOnFocus?: boolean;
  noMatchAlert?: string;
  hideNoMatchAlert?: boolean;
  addressValues?: Array<string>;
  disabled?: boolean;
  required?: boolean;
};

export default function SearchSelector(props: SearchSelectorProps): ReactElement {
  const {
    htmlFor,
    title,
    value,
    subtitle,
    highLightOnFocus,
    noMatchAlert,
    hideNoMatchAlert,
    disabled,
    required,
  } = props;

  const {
    open,
    setOpen,
    optionsList,
    parentId,
    showWarning,
    checkWarning,
    optionSelectHandler,
    innerChangeHandler,
  } = useSearchSelector(props);

  // const { t } = useTranslation();
  const t = (s: string) => s;
  const [highLight, setHighLight] = useState(false);

  let searchSelector;
  if (disabled) {
    searchSelector = styles.searchSelectorDisabled;
  } else {
    searchSelector = styles.searchSelector;
  }

  const fieldIsRequired = () => {
    if (required && value) {
      return false;
    } else if (!required) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div id={parentId} className={styles.searchBox}>
      <label htmlFor={htmlFor}>
        <p className={highLight ? styles.highLight : ''}>{title}</p>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        <input
          id={`${htmlFor}_${parentId}`}
          className={searchSelector}
          type="text"
          value={value}
          onChange={innerChangeHandler}
          autoComplete="somerandomstring"
          disabled={disabled}
          onFocus={() => {
            setOpen(true);
            if (highLightOnFocus) {
              setHighLight(true);
            }
          }}
          onBlur={() => {
            checkWarning();
            if (highLightOnFocus) {
              setHighLight(false);
            }
          }}
          required={fieldIsRequired()}
        />
      </label>
      {!hideNoMatchAlert && showWarning ? (
        <div className={styles.box__passwordAlert}>
          <ul id="password-reqs-list" className={styles.box__passwordInner}>
            <div className={styles.triangle} />
            <li className={`${styles.box__passwordText}`}>
              <img src={alertPic} alt="" className={styles.alert} />
              {t(noMatchAlert || required ? 'Exact match is required' : 'No match found')}
            </li>
          </ul>
        </div>
      ) : null}{' '}
      {open && optionsList.length > 0 ? (
        <div className={styles.searchList}>
          {optionsList.map((o, idx) => (
            <button key={`${o}_${idx}`} onClick={() => optionSelectHandler(o)}>
              {o}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
SearchSelector.defaultProps = {
  selectHandler: undefined,
  subtitle: undefined,
  highLightOnFocus: false,
  noMatchAlert: undefined,
  disabled: undefined,
};
